import { ModelValue } from "../../../Engine/Core/CoreTypes";
import { ensureIsArray, isNotNullOrEmpty } from "../../../../../Common/TypingUtils";

export const extractDirtyCheckboxesArray = (modelValue: ModelValue | undefined) => {
    let currentValue: string[];
    try {
        currentValue = ensureIsArray(
            JSON.parse(typeof modelValue === "string" && isNotNullOrEmpty(modelValue) ? modelValue : "[]")
        );
    } catch {
        currentValue = [];
    }
    return currentValue;
};
